import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PaymentService } from '../../../services/payment.service';
import { Payment } from '../../../models/payment';

declare var RealexHpp: any;

@Component({
  selector: 'app-global-payment',
  templateUrl: './global-payment.component.html',
  styleUrls: ['./global-payment.component.css']
})

export class GlobalPaymentComponent implements OnInit {
  @Input() chamberId: string;
  @Input() paymentToken: string;
  @Input() source: string;
  @Input() userId: string;
  @Input() allowCardSaving: boolean;

  @Output() paymentError: EventEmitter<any> = new EventEmitter();

  loading: boolean;

  constructor(private paymentService: PaymentService) { }

  ngOnInit() {
    this.loading = false;
  }

  initiatePayment(hiddenGlobalHppButton: any) {
    this.loading = true;

    let callbackUrl = environment.apiURL + 'Payment/' + this.paymentToken + '/Global?chamberId=' + this.chamberId;
    if (this.source && this.source.trim() !== '') {
      callbackUrl += '&paymentsource=' + this.source;
    }
    if (this.userId && this.userId.trim() !== '') {
      callbackUrl += '&userid=' + this.userId;
    }

    this.paymentService.getPayment(this.paymentToken, this.chamberId)
    .then((payment: Payment) => {
      if (!environment.production) {
        RealexHpp.setHppUrl('https://pay.sandbox.realexpayments.com/pay');
      }
      RealexHpp.init('hiddenPayButtonGlobal',
        callbackUrl,
        JSON.parse(payment.GlobalPayment),
        this.callback.bind(this));
      //this.loading = false;
      hiddenGlobalHppButton.click();
    })
    .catch((error) => {
      this.loading = false;
      this.paymentError.emit(error);
    });
  }

  callback() {
    this.loading = false;
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/components/payment/global-payment/global-payment.component.ts